// Google Sheets Configuration
export const GOOGLE_SHEETS = {
  SHEET_ID: '1q9uR0Ie6io-yEAC1C78fhV-DSm65QgvXVdd6WP57IRQ',
  GID: '1433429779',
  get API_URL() {
    return `https://docs.google.com/spreadsheets/d/${this.SHEET_ID}/gviz/tq?tqx=out:json&gid=${this.GID}`;
  }
};

// Ukrainian UI Text
export const UI_TEXT = {
  // Header
  appTitle: 'Бібліотечний каталог',
  appSubtitle: 'Ліцей № 309 Дарницького району м.Києва',
  
  // Search
  searchPlaceholder: 'Пошук за назвою або автором...',
  searchLabel: 'Пошук книг',
  
  // Filters
  filterGenre: 'Фільтр за жанром',
  filterAge: 'Вік',
  filterNew: 'Тільки новинки',
  allGenres: 'Усі жанри',
  allAges: 'Усі вікові категорії',
  
  // Book Fields
  isNew: 'Новинка',
  title: 'Назва',
  author: 'Автор',
  genre: 'Жанр',
  ageCategory: 'Вік',
  description: 'Короткий опис',
  pubYear: 'Рік видання',
  origYear: 'Рік публікації твору',
  isbn: 'ISBN-13',
  status: 'Статус',
  borrowedBy: 'Позичив',
  borrowDate: 'Дата позики',
  returnDate: 'Дата повернення',
  
  // Status
  available: 'Доступна',
  borrowed: 'Позичена',
  
  // Messages
  loading: 'Завантаження...',
  error: 'Помилка завантаження даних',
  notFound: 'не знайдено',
  booksFound: 'книг знайдено',
  
  // Pagination
  prevPage: 'Попередня сторінка',
  nextPage: 'Наступна сторінка',
  paginationNav: 'Навігація сторінками',

  // Admin
  adminLogin: 'Вхід для адміністратора',
  adminPassword: 'Пароль',
  adminLoginButton: 'Увійти',
  adminLogout: 'Вийти',
  wrongPassword: 'Неправильний пароль',

  // Reading list
  myList: 'Мій список',
  clearList: 'Очистити',
  readingListNote: 'Список зберігається у браузері протягом 60 днів. Він доступний лише на цьому пристрої.',
  daysLeft: 'ще',
  days: 'днів',
  addToList: 'Додати до списку',
  removeFromList: 'Збережено у списку'
};

// Age Categories
export const AGE_CATEGORIES = ['Усі', '6+', '8+', '10+', '12+', '14+', '16+'];
